import { Injectable } from '@angular/core';
import { Paginator, SortDirection } from '@app/classes';
import { AnalyticEvents } from '@app/enums';
import { Table } from '@app/modules/table/classes/table.class';
import { AnalyticService, AuthService } from '@app/services';
import {
    ArchivedColumn,
    DateAddedColumn,
    FullNameColumn,
} from '@applicant-tracker/services/tables/applicants-table/columns';
import { JobFunnelColumn } from '@applicant-tracker/services/tables/applicants-table/columns/job-funnel.column';
import { RatingColumn } from '@applicant-tracker/services/tables/applicants-table/columns/rating.column';
import { Applicant } from '@models/recruiting/applicant.model';
import { JobPosting } from '@models/recruiting/job-posting.model';

@Injectable()
export class JobPostingApplicantsIndexTable extends Table {
    sortDirection = SortDirection.ASC;
    links = true;
    protected sortProperty = 'lastName';
    private jobPosting: JobPosting;

    constructor(
        protected auth: AuthService,
        private analyticService: AnalyticService
    ) {
        super(auth);
        // Need to set the data source since the paginator will have a null value otherwise which will cause `undefined` errors on the template.
        this.setDataSource();
    }

    getLink(applicant: Applicant): (string | number)[] {
        return ['/recruiting', 'applicants', applicant.id];
    }

    setColumns(): void {
        const companyId = this.auth.company.id;

        const nameColumn = new FullNameColumn();
        this.columns = [];

        const columns = [
            nameColumn,
            new DateAddedColumn(),
            new ArchivedColumn(),
            new RatingColumn(),
            new JobFunnelColumn(
                companyId,
                this.analyticService,
                AnalyticEvents.RecruitingJobPostingApplicantsChangeApplicantFunnelStage,
                this.jobPosting.id
            ),
        ];

        this.addColumns(...columns);

        this.sortColumn = nameColumn;
    }

    scopeToJobPosting(jobPosting: JobPosting): void {
        // don't reload if it's the same job
        if (this.jobPosting && this.jobPosting.id === jobPosting.id) {
            return;
        }

        this.jobPosting = jobPosting;
        this.clearFilters();
        this.boot();

        this.paginator.onLoading((loading) => {
            this.onLoading.next(loading);
        });
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            Applicant.param('company', this.auth.company.id)
                .with(['jobPosting', 'jobPosting.jobFunnels'])
                .when(this.jobPosting, (query) => query.where('jobId', this.jobPosting.id))
        );
    }
}
